<template>
  <div class="distributor-order-list">
    <div class="common-header-wrap">
      <mt-header :title="$t('distributor.title.history')" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
		<div class="common-btn btn" slot="right" @click="rightAction">{{ $t('distributor.general.filter') }}</div>
      </mt-header>
    </div>
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
    <div v-if="order_list && order_list.length" class="list-wrapper">
      <div v-for="order in order_list" :key="order.order_id" class="order-item" @click="getOrderInfo(order.order_id)">
        <div class="left">
          <div class="info">{{ $t('distributor.order.destination') }}：{{order.buyer_address}}</div>
          <div class="info">{{ $t('distributor.order.time') }}：{{$moment.unix(order.finnshed_time).format('YYYY.MM.DD HH:mm')}}</div>
          <div class="time"><span class="strong">{{order.use_time}}</span>{{ $t('distributor.general.unit_minute') }}</div>
        </div>
        <div class="right">
          <div class="distance">{{order.o2o_order_distance}}km</div>
          <div class="goods_list">
            <div class="item" v-for="(goods,index) in order.goods_list">
              <img v-if="order.goods_num<4 || index<2" :src="goods.goods_image_url">
              <span v-if="order.goods_num>3" class="iconfont">&#xe66a;</span>
            </div>

          </div>
        </div>
      </div>
    </div>
    <empty-record v-else-if="order_list && !order_list.length"></empty-record>
  </div>
    <!--订单详情-->
    <mt-popup v-model="orderDetailVisible" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header :title="$t('distributor.order.order_detail')" class="common-header">
          <mt-button slot="left" icon="back" @click="orderDetailVisible=false"></mt-button>
        </mt-header>
      </div>
      <distributor-order-detail v-bind:order_id="order_id" />
    </mt-popup>
		<!--筛选-->
		<mt-popup v-model="orderSelectVisible" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header :title="$t('distributor.general.filter')" class="common-header">
          <mt-button slot="left" icon="back" @click="orderSelectVisible=false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content" style="top: 4rem">
			<mt-field :label="$t('distributor.order.start_time')" type="date" v-model="time_start"></mt-field>
			<mt-field :label="$t('distributor.order.end_time')" type="date" v-model="time_end"></mt-field>

			<mt-button type="primary" @click='searchOrder' size="large">{{ $t('general.confirm') }}</mt-button>
			</div>
    </mt-popup>
  </div>
</template>

<script>
import { getOrderList } from '../../../api/distributorOrder'
import { Toast,Indicator } from 'mint-ui'
import { mapState } from 'vuex'

import EmptyRecord from '../../../components/EmptyRecord'
import DistributorOrderDetail from '../common/DistributorOrderDetail'
export default {
  components: {
    DistributorOrderDetail,

    EmptyRecord
  },
  name: 'DistributorOrderList',
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      order_id: 0,
      orderSelectVisible: false,
      orderDetailVisible: false,
      wrapperHeight: 0,

      order_list: false,

      time_start: '',
      time_end: ''
    }
  },

  mounted () {
    this.wrapperHeight = document.documentElement.clientHeight - 90
  },
  computed: {
    ...mapState({
      user: state => state.distributor.info
    })
  },
  created: function () {
  },

  methods: {
    searchOrder () {
      this.getOrderList(true)
      this.orderSelectVisible = false
    },
    rightAction () {
      this.orderSelectVisible = true
    },
    getOrderInfo (orderId) {
      this.orderDetailVisible = true
      this.order_id = orderId
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getOrderList(false)
      }
    },
    getOrderList (ifReplace) {
      Indicator.open()
      if (ifReplace) {
        this.loading = false
        this.params.page = 1
        this.isMore = true
      }


          getOrderList(this.params, 'history', { time_start: this.time_start, time_end: this.time_end }).then(res => {
            Indicator.close()
            if (res.result.hasmore) {
              this.isMore = true
            } else {
              this.isMore = false
            }

            let tOrderList = res.result.order_list

            if (tOrderList) {
              if (ifReplace || !this.order_list) {
                this.order_list = tOrderList
              } else {
                this.order_list = this.order_list.concat(tOrderList)
              }
            }
          }).catch(function (error) {
            Indicator.close()
            Toast(error.message)
          })

    }
  }
}
</script>
<style  lang="scss" scoped>
  .list-wrapper {
    padding-bottom: 6rem;
    overflow-y: scroll;
    height: calc(90vh - 4rem);
  }
	.common-header{
	    .btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
	}
  .distributor-order-list {
    .order-item {
      border-bottom: 1px solid #eee;
      background: #fff;
      padding: .5rem;
      display: flex;
      .left {
        flex: 4;
        overflow: hidden;
        .info {
          font-size: .7rem;
          color: #000;
          line-height: 1.5;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .time {
          font-size: .6rem;
          color: #ff7007;
          .strong {
            font-size: 1rem;
            margin-right: .2rem
          }
        }
      }
      .right {
        flex: 1;
        text-align: right;
        .distance {
          font-size: .6rem;
          color: #999
        }
        .goods_list {
          position: relative;
          .item {
            position: absolute;
            top: .7rem;
            text-align: center;
            border: 1px solid #eee;
            border-radius: 50%;
            width: 1.8rem;
            color: #999;
            line-height: 1.8rem;
            height: 1.8rem;
						font-size:0;
						overflow:hidden;
            img {
              height: 100%;
              width: 100%;
            }
          }
          .item:nth-last-child(1) {
            right: 0rem;
            z-index: 1
          }
          .item:nth-last-child(2) {
            right: 1rem;
            z-index: 2
          }
          .item:nth-last-child(3) {
            right: 2rem;
            z-index: 3
          }
        }
      }
    }
  }

</style>
